<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { RadioGroupRoot } from 'reka-ui'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'
import { PreferredLanguage } from '~/models/User/PreferredLanguage'
import Button from '~/components/ui/Button.vue'
import AuRadio from '~/components/ui/AuRadio.vue'

const { t } = useI18n()
const authStore = useAuthStore()

const { userPreferredLanguage } = storeToRefs(authStore)

const selectedLanguage = computed({
  get: () => userPreferredLanguage.value,
  set: lang => authStore.setPreferredLanguage(lang)
})

const languages = [PreferredLanguage.Bokmal, PreferredLanguage.Nynorsk]
</script>

<template>
  <div>
    <p
      class="text-gray-50"
      v-text="t('filters.chooseLanguage')"
    />
    <RadioGroupRoot
      v-model="selectedLanguage"
      as="fieldset"
      class="mt-6 flex gap-2"
    >
      <Button
        v-for="lang in languages"
        :key="lang"
        type="label"
        variant="outline"
      >
        <AuRadio
          shade="dark"
          :value="lang"
        />
        {{ t(`metadata.language.${lang}`) }}
      </Button>
    </RadioGroupRoot>
  </div>
</template>
